// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__54MAP","log":"ModalInventoryLogs_log__1oZFu","date":"ModalInventoryLogs_date__1aaI_","userName":"ModalInventoryLogs_userName__3efrk"};